import instituteSelector from 'modules/Auth/selectors'
import corporateRequest from 'utils/corporateRequest'
import ErrorMessage from 'utils/ErrorMessage'
import instRequest from 'utils/instRequest'
import SuccessMessage from '../../utils/SuccessMessage'
export const SET_ROLES_LIST = 'institute/SET_ROLES_LIST'
export const SET_RULE_ENGINE = 'institute/SET_RULE_ENGINE'
export const SET_CORP_LIST = 'institute/SET_CORP_LIST'
export const SET_RULE_LIST = 'institute/SET_RULE_LIST'
export const SET_RULE_LIST_WAY = 'institute/SET_RULE_LIST_WAY'
export const SET_RULE_DETAILS = 'institute/SET_RULE_DETAILS'
export const SET_ALREADY_SET_DEGREE_LIST =
  'institute/SET_ALREADY_SET_DEGREE_LIST'
export const SET_RULES_DEGREES_METRICS = 'institute/SET_RULES_DEGREES_METRICS'
export const SET_SELECTED_DEGREE_DEPARTMENT = 'SET_SELECTED_DEGREE_DEPARTMENT'
export const SET_DEGREE_STREAM_MAP = 'institute/SET_DEGREE_STREAM_MAP'
export const SET_RULES_STATIC_DETAILS = 'institute/SET_RULES_STATIC_DETAILS'
export const SET_IS_RULES_EDITED = 'institute/SET_IS_RULES_EDITED'
export const setRolesList = data => {
  return {
    type: SET_ROLES_LIST,
    data,
  }
}
export const setRuleEngine = data => {
  return {
    type: SET_RULE_ENGINE,
    data,
  }
}
export const setCorporateList = data => {
  return {
    type: SET_CORP_LIST,
    data,
  }
}
export const setRuleList = data => {
  return {
    type: SET_RULE_LIST,
    data,
  }
}
export const seRuleListWay = data => {
  return {
    type: SET_RULE_LIST_WAY,
    data,
  }
}
export const setRuleDetails = data => {
  return {
    type: SET_RULE_DETAILS,
    data,
  }
}
export const setAlreadySetDegreeList = data => {
  return {
    type: SET_ALREADY_SET_DEGREE_LIST,
    data,
  }
}
export const setRulesDegreesMetrics = data => {
  return {
    type: SET_RULES_DEGREES_METRICS,
    data,
  }
}
export const setDegreeStreamMap = data => {
  return {
    type: SET_DEGREE_STREAM_MAP,
    data,
  }
}

export const setSelectedDegreesAndDepartmentsList = data => ({
  type: SET_SELECTED_DEGREE_DEPARTMENT,
  data,
})

export const setRuleStaticDetails = data => ({
  type: SET_RULES_STATIC_DETAILS,
  data,
})

export const setIsRuleEdited = data => ({
  type: SET_IS_RULES_EDITED,
  data,
})

export const getRolesListData =
  (setLoading, query = null) =>
  async (dispatch, getState) => {
    setLoading(true)
    try {
      const info = await corporateRequest.get(`/designations?${query}`)
      dispatch(setRolesList(info?.data?.data))
      setLoading(false)
      return info?.data
    } catch (error) {
      setLoading(false)
    }
  }
export const updateRuleEngine = data => async (dispatch, getState) => {
  const state = getState()
  const institute_id = instituteSelector.getInstituteDetails(state).id
  try {
    const info = await instRequest.put(`/institutes/${institute_id}/rule`, data)
    if (info?.status === 200) {
      SuccessMessage('Updated successfully')
    }
  } catch (error) {}
}
export const getRuleEngine = () => async (dispatch, getState) => {
  const state = getState()
  const institute_id = instituteSelector.getInstituteDetails(state).id
  try {
    const info = await instRequest.get(`/institutes/${institute_id}/rule`)

    if (info?.status === 200) {
      dispatch(setRuleEngine(info?.data?.data))
    }
  } catch (error) {
    ErrorMessage(error?.response?.data?.message)
  }
}
export const getCorporateListFromCorporate =
  (setLoading, pageNo = 0, search = '') =>
  async (dispatch, getState) => {
    try {
      setLoading(true)
      const info = await corporateRequest.get(
        `/corporates/list?pageLimit=20&currentPage=${pageNo}&isActive=true&search=${search}`
      )
      if (info?.status === 200 || info?.status === 201) {
        dispatch(setCorporateList(info?.data?.data))
      }
      setLoading(false)
      return info
    } catch (err) {
      if (err?.response?.data?.message)
        ErrorMessage(err?.response?.data?.message)
    }
  }
export const getRuleSetData =
  ({
    setLoading,
    pageNo = 0,
    status = 1,
    sort = '',
    orderBy = 'asc',
    search = '',
  }) =>
  async (dispatch, getState) => {
    try {
      setLoading(true)
      const state = getState()
      const institute_id = instituteSelector.getInstituteDetails(state).id
      const sortParam = sort && orderBy ? `&sort=${sort}&order=${orderBy}` : ''
      const searchParam = search ? `&search=${search.trim()}` : ''

      const info = await instRequest.get(
        `/institutes/${institute_id}/rules/list?pageLimit=10&pageNo=${
          pageNo - 1
        }&status=${status}${sortParam}${searchParam}`
      )
      dispatch(setRuleList(info?.data?.data))
    } catch (err) {
      if (err?.response?.data?.message)
        ErrorMessage(err?.response?.data?.message)
    } finally {
      setTimeout(() => {
        setLoading(false)
      }, 500)
    }
  }

export const deleteRule =
  ({ ruleId }) =>
  async (dispatch, getState) => {
    try {
      const state = getState()
      const institute_id = instituteSelector.getInstituteDetails(state).id
      const response = await instRequest.delete(
        `/institutes/${institute_id}/rule/${ruleId}`
      )
      if (response?.status >= 200 && response?.status <= 300) {
        SuccessMessage('Rule Set is deleted')
      }
      return response
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
      return error
    }
  }

export const createRules = data => async (dispatch, getState) => {
  try {
    const state = getState()
    const institute_id = instituteSelector.getInstituteDetails(state).id
    data.instituteCampusId = institute_id
    const response = await instRequest.post(
      `/institutes/${institute_id}/rules`,
      data
    )
    return response
  } catch (err) {
    if (err?.response?.data?.message) ErrorMessage(err?.response?.data?.message)
  }
}
export const degreeStreamMap =
  ({ degreeStreamMapIds, page, search }) =>
  async (dispatch, getState) => {
    try {
      let payload = {
        degreeStreamMapIds: degreeStreamMapIds,
        isPaginated: true,
        pageNo: page - 1,
        search: search,
      }
      const result = await instRequest.post(
        `/institutes/degreeStreamMap`,
        payload
      )
      dispatch(setDegreeStreamMap(result?.data?.data || []))
      return result?.data?.data || []
    } catch (err) {
      ErrorMessage(err?.response?.data?.message)
    }
  }

export const updateRules = (data, ruleId) => async (dispatch, getState) => {
  try {
    const state = getState()
    const institute_id = instituteSelector.getInstituteDetails(state).id
    data.instituteCampusId = institute_id
    const response = await instRequest.put(
      `/institutes/${institute_id}/rule/${ruleId}`,
      data
    )
    return response
  } catch (err) {
    if (err?.response?.data?.message) ErrorMessage(err?.response?.data?.message)
  }
}

export const getInstituteRulesById = ruleId => async (dispatch, getState) => {
  try {
    const state = getState()
    const institute_id = instituteSelector.getInstituteDetails(state).id
    const response = await instRequest.get(
      `/institutes/${institute_id}/rules/${ruleId}`
    )
    if (response?.status === 200) {
      dispatch(setRuleDetails(response?.data?.data))
    }
    return response?.data?.data
  } catch (err) {
    if (err?.response?.data?.message) ErrorMessage(err?.response?.data?.message)
  }
}

export const setUpNewRules = () => async (dispatch, getState) => {
  try {
    const state = getState()
    const institute_id = instituteSelector.getInstituteDetails(state).id
    const result = await instRequest.get(
      `institutes/${institute_id}/rules/degrees/metrics`
    )
    dispatch(setRulesDegreesMetrics(result?.data?.data))
    return result?.data?.data
  } catch (err) {
    if (err?.response?.data?.message) ErrorMessage(err?.response?.data?.message)
  }
}

export const checkRuleSet = ruleId => async (dispatch, getState) => {
  try {
    const query = ruleId ? `?ruleId=${ruleId}` : ''
    const state = getState()
    const institute_id = instituteSelector.getInstituteDetails(state).id
    const response = await instRequest.get(
      `/institutes/${institute_id}/rules/degrees${query}`
    )
    if (response?.status === 200) {
      dispatch(setAlreadySetDegreeList(response?.data?.data))
    }
    return response?.data?.data || []
  } catch (err) {
    if (err?.response?.data?.message) ErrorMessage(err?.response?.data?.message)
  }
}

export const ruleOverwrite =
  (payload, ruleId) => async (dispatch, getState) => {
    try {
      const state = getState()
      const institute_id = instituteSelector.getInstituteDetails(state).id
      const params = ruleId ? `?ruleId=${ruleId}` : ''
      const response = await instRequest.put(
        `/institutes/${institute_id}/rule/overwrite${params}`,
        payload
      )
      return response
    } catch (err) {
      if (err?.response?.data?.message)
        ErrorMessage(err?.response?.data?.message)
    }
  }
